module.exports = " <div class=container> <div class=page-header> <h1>Logging out...</h1> </div> </div> ";